"use client";

import SimpleListingCard from "@/components/search/simple-listing-card";
import {
  type ListingItem,
  toSearchSimpleListingCardProps,
} from "@/components/Landing/components/simple-listing-card";

export interface ListingsCarouselProps {
  items: ListingItem[];
}

export function ListingsCarousel(props: ListingsCarouselProps) {
  const { items } = props;
  if (items.length === 0) return null;

  const third = Math.ceil(items.length / 3);
  const col1 = items.slice(0, third);
  const col2 = items.slice(third, third * 2);
  const col3 = items.slice(third * 2);

  const dup1 = [...col1, ...col1];
  const dup2 = [...col2, ...col2];
  const dup3 = [...col3, ...col3];

  return (
    <div className="relative h-full overflow-hidden">
      <div className="h-full flex gap-4 px-4">
        <div className="flex-1 min-w-0 flex flex-col gap-4 animate-scroll-up">
          {dup1.map((item, index) => (
            <div key={`col1-${item.id}-${index}`} className="w-full min-w-0 flex justify-center">
              <div className="w-full max-w-64">
                <SimpleListingCard
                  {...toSearchSimpleListingCardProps(item, {
                    interactive: false,
                    disableHoverOverlay: true,
                  })}
                />
              </div>
            </div>
          ))}
        </div>
        <div className="flex-1 min-w-0 flex flex-col gap-4 animate-scroll-down">
          {dup2.map((item, index) => (
            <div key={`col2-${item.id}-${index}`} className="w-full min-w-0 flex justify-center">
              <div className="w-full max-w-64">
                <SimpleListingCard
                  {...toSearchSimpleListingCardProps(item, {
                    interactive: false,
                    disableHoverOverlay: true,
                  })}
                />
              </div>
            </div>
          ))}
        </div>
        <div className="flex-1 min-w-0 flex flex-col gap-4 animate-scroll-up">
          {dup3.map((item, index) => (
            <div key={`col3-${item.id}-${index}`} className="w-full min-w-0 flex justify-center">
              <div className="w-full max-w-64">
                <SimpleListingCard
                  {...toSearchSimpleListingCardProps(item, {
                    interactive: false,
                    disableHoverOverlay: true,
                  })}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="absolute inset-x-0 top-0 h-32 bg-linear-to-b from-background to-transparent pointer-events-none" />
      <div className="absolute inset-x-0 bottom-0 h-32 bg-linear-to-t from-background to-transparent pointer-events-none" />
      <div className="absolute inset-y-0 left-0 w-16 bg-linear-to-r from-background to-transparent pointer-events-none" />
      <div className="absolute inset-y-0 right-0 w-16 bg-linear-to-l from-background to-transparent pointer-events-none" />
    </div>
  );
}
